import React from "react";
import PropTypes from "prop-types";

const Pagination = ({ totalResults, currentPage, pageSize, onPageBack, onPageForward, onChangePage }) => {

    var pages = [];
    var totalPages = Math.ceil(totalResults / pageSize); 
    var firstPage = 1;
    var lastPage = totalPages; 

    if (totalPages > 10) {
        if (currentPage > 6) {
            firstPage = currentPage - 5;
            lastPage = currentPage <= totalPages - 4 ? currentPage + 4 : totalPages;
        }
        else {
            lastPage = 10;
        }
    }

    for (var i = firstPage; i <= lastPage; i++) {
        pages.push(<li key={i} className={i == currentPage ? "btn btn-link page-item active" : "btn btn-link page-item"} onClick={onChangePage} value={i}>{i}</li>);
    }

    return (
        <nav className="pagination-container col-md-12 text-center">
            <ul className="pagination">
                <li className={currentPage === 1 ? "page-nav btn btn-link disabled" : "page-nav btn btn-link"} onClick={onPageBack} aria-label="Previous">
                        <span className="fas fa-arrow-circle-left" aria-hidden="true"></span>
                </li>
                {pages}
                <li className={currentPage === Math.ceil(totalResults / pageSize) ? "page-nav btn btn-link disabled" : "page-nav btn btn-link"} onClick={onPageForward} aria-label="Next">
                        <span className="fas fa-arrow-circle-right" aria-hidden="true"></span>
                </li>
            </ul>
            <div className="pagination-summary">{`${totalResults} Results - Page ${currentPage} of ${Math.ceil(totalResults / pageSize)}`}</div>
        </nav>
    );
};

Pagination.propTypes = {
    totalResults: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    onPageBack: PropTypes.func.isRequired,
    onPageForward: PropTypes.func.isRequired,
}

export default Pagination; 


// WEBPACK FOOTER //
// ./src/components/common/Pagination.js